import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'

const PatientDetails = React.lazy(() => import("../../components/BookConsultNow/Components/PatientDetails/PatientDetail"));
const ChooseDoctor = React.lazy(() => import("../../components/BookConsultNow/Components/ChooseDoctor/ChooseDoctor"));
const PatientMedical = React.lazy(() => import("../../components/BookConsultNow/Components/PatientMedicalComponent/PatientMedicalComponent"));
const ConsultationHistory = React.lazy(() => import("../../components/BookConsultNow/Components/ConsultationHistory/ConsultationHistory"));

function BookConsultNowRoutes({ isSchedule }) {

    let { path, url } = useRouteMatch();


    return (
        <Switch>

            {/* <Route
                index
                path={`${path}/patientdetails`}
                component={PatientDetails}
            /> */}

            <Route
                exact
                path={`${path}`}
                component={PatientDetails}
            />

            <Route
                path={`${path}/patientdetails`}
                component={PatientDetails}
            />

            <Route

                path={`${path}/choosedoctor`}
                component={ChooseDoctor}
            />

            <Route

                path={`${path}/patientmedical`}
                component={PatientMedical}
            />

            <Route

                path={`${path}/consultationhistory`}
                component={ConsultationHistory}
            />

        </Switch>
    )
}

export default BookConsultNowRoutes